import gql from "graphql-tag";

import {useQuery} from "@khan/data-gql";
import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {allCoacheeNamesType} from "./__graphql-types__/index.ts";

export const ALL_COACHEE_NAMES_QUERY: GqlOperation<
    allCoacheeNamesType["response"],
    allCoacheeNamesType["variables"]
> = gqlOp(gql`
    query allCoacheeNames {
        user {
            id
            coachedClassrooms {
                descriptor
                cacheId
                id
                studentKaidsAndNicknames {
                    id
                    coachNickname
                }
            }
            children {
                id
                nickname
            }
        }
    }
`);

// Get the nicknames for the current user's coachees. If a classroom descriptor
// is provided, get student names for that classroom only.
export const useCoacheeNamesWithClassroomFilter = (
    classroomDescriptor?: string | null,
): Array<string> => {
    const [queryResult] = useQuery(ALL_COACHEE_NAMES_QUERY);

    if (queryResult.status !== "success") {
        return [];
    }

    // Add student names, potentially filtered by classroom descriptor.
    const studentNames: Set<string> = new Set<string>();
    for (const classroom of queryResult.data.user?.coachedClassrooms ?? []) {
        if (
            !classroomDescriptor ||
            classroom?.descriptor === classroomDescriptor
        ) {
            for (const student of classroom?.studentKaidsAndNicknames ?? []) {
                studentNames.add(student?.coachNickname ?? "");
            }
        }
    }
    // Add child names as well if no classroom descriptor is provided.
    if (!classroomDescriptor) {
        for (const child of queryResult.data.user?.children ?? []) {
            studentNames.add(child?.nickname ?? "");
        }
    }

    return Array.from(studentNames);
};
